import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import BarChartCommonComponent from '../../../library/SimpleControls/BarChartCommonComponent';
import useDashboard from './useDashboard';

const AverageSalaryRangeByExperience = () => {
    const { state } = useContext(SmartContext);
    const { getAverageSalaryRangeByExperience } = useDashboard();

    useEffect(() => {
        getAverageSalaryRangeByExperience();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.averageSalaryRangeByExperience))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state?.data?.dashboardData?.averageSalaryRangeByExperience} />
        </>
    );
};

export default AverageSalaryRangeByExperience;
